<template>
  <div class="categories">

    <v-card-text>

      <div class="chat-list" v-for="item in items" :key="item.Id">
        <v-card v-on:click="goToModel(item.Id,item.SubGroupTitle)" :color="get_item_color(item.Id)">
          <div class="row" style="margin-top: 0px">
            <div class="col-2" style="padding-right: 0px;align-self: center;">
              <img style="width: 44px;height: 44px" class="rounded-circle" :src="item.ImageUrl"/>
            </div>
            <div class="col-8" style="align-self: center;">
            <span class="name">
              {{item.SubGroupTitle}}
            </span>
            </div>
            <div class="col-1" style="align-self: center;">
              <v-icon color="#1976d2">
                mdi-chevron-left
              </v-icon>
            </div>
          </div>


        </v-card>

      </div>
      <v-row justify="center">
        <v-dialog
          v-model="dialog_model"
          max-width="290"
          fullscreen
          hide-overlay
        >

          <v-card class="category-modal">
            <v-card-title class="headline">
              {{$t('deviceModel')}}
            </v-card-title>
            <v-card-text>
              <v-row>

                <treeselect
                  :multiple="false"
                  :load-options="load_models"
                  :normalizer="normalizer_models"
                  :async="true"

                  :placeholder="$t('searchDeviceModel')"
                  v-model="auto_complete_model"
                />

              </v-row>
              <br>
              <br>
              <br>
              {{$t('selectedModel')}}

              <label>{{model_txt}}</label>

            </v-card-text>
            <v-card-actions class="">
              <v-spacer></v-spacer>

              <v-btn
                class="cancle-btn"
                text
                @click="dialog_model = false"
              >
                {{$t('cancel')}}
              </v-btn>
              <v-btn
                v-if="model_txt != ''"
                class="accept-btn"
                text
                @click="goToDetail()"
              >
                {{$t('ok')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>

    </v-card-text>

  </div>

</template>

<script>
  // const wikiUrl = 'https://en.wikipedia.org'
  // const params = 'action=query&list=search&format=json&origin=*'
  import Treeselect from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'

  import axios from 'axios'
  import Vue from 'vue'
  import { ASYNC_SEARCH } from '@riophae/vue-treeselect'

  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }
  export default {
    components: { Treeselect },

    data () {
      return {
        auto_complete_model: null,
        search_entries: [],
        model_txt: '',

        selected_item_id: '',
        loading: false,

        select: null,

        model_items: [],
        items: [],
        errors: [],
        form_valid: false,
        device_model: '',
        dialog_model: '',

        normalizer_models (node) {
          return {
            id: node.Id,
            label: node.Title,
          }
        },
      }
    },
    computed: {

    },
    watch: {
      auto_complete_model () {
        for (var i = 0; i < this.search_entries.length; i++) {
          if (this.search_entries[i].Id == this.auto_complete_model) {
            this.model_txt = this.search_entries[i].Title
          }
        }
      },

      select (val) {
        console.log('select', val)
      }
    },
    mounted () {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
      console.log('request data', passing_data)
      console.log('request data model', passing_data.model_title)
      this.selected_item_id = passing_data.brand_id
      if (passing_data.model_title != null) {
        this.device_model = passing_data.model_title
        this.model_txt = passing_data.model_title
        console.log("title is",this.device_model)
      }
      this.get_categories()
    },
    methods: {

      load_models ({ action, searchQuery, callback }) {
        this.model_txt = searchQuery
        var self = this
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options

            var passing_data = JSON.parse(localStorage.getItem('request_data'))

            const send_data = {
              txt: searchQuery,
              sgid: passing_data.brand_id,
            }
            this.axios.post('/GetProductModels', send_data, {})
              .then(response => {
                self.search_entries = response.data.results
                options = response.data.results
                callback(null, options)
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })

            //
            // axios.post('/api/admin/product_search-tags', {
            //   search: searchQuery,
            //
            // }).then(function (response) {
            //   options = response.data;
            //   callback(null, options);
            //   // localStorage.setItem("api_token", response.data.access_token);
            //   // self.$router.push({ path: 'notes' });
            // })
            //   .catch(function (error) {
            //     self.message = 'Incorrect E-mail or password';
            //     self.showMessage = true;
            //     console.log(error);
            //   });

            //  const options = this.get_keywords(searchQuery);
            // const options = [1, 2, 3, 4, 5].map(i => ({
            //     id: `${searchQuery}-${i}`,
            //     name: `${searchQuery}-${i}`,
            // }))
          })
        }
      },

      get_item_color (item_id) {
        if (item_id == this.selected_item_id) {
          return '#cee2f7'
        } else {
          return 'white'
        }
      },
      goToModel (item_id, title) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.brand_id = item_id
        passing_data.request_name = passing_data.request_name + title + ' '

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.dialog_model = true
      },
      goToDetail () {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.device_model = this.model_txt
        if (this.auto_complete_model == null) {
          passing_data.device_model_id = 0
        } else {
          passing_data.device_model_id = this.auto_complete_model
        }

        localStorage.setItem('request_data', JSON.stringify(passing_data))
        this.$router.push({ name: 'predefined', params: {} })
      },
      get_categories () {
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var sub_group_id = passing_data.sub_group_id
        const send_data = {
          groupId: sub_group_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetReqCategorySubGroupListRelByGrpId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('brands get ' + response.data.subGroups)
              self.items = response.data.subGroups
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      }
    }
  }
</script>
